const isILink = (item) => "href" in item;
function getSanitizedLanguagePickerCTA(config) {
  const { location, languagePickerCTA, currentLanguage, secondLanguageCTA, ...rest } = config;
  return {
    ...rest
  };
}
function countCTAListsWithItems(data) {
  return (data.CTALists || []).reduce((count, group) => {
    const groups = Array.isArray(group) ? group : [group];
    const hasItems = groups.some((g) => Array.isArray(g.items) && g.items.length > 0);
    return hasItems ? count + 1 : count;
  }, 0);
}

export { countCTAListsWithItems, getSanitizedLanguagePickerCTA, isILink };
